import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import Box from 'ui-box';
import { Row, Col, Typography, Button, Divider, Select } from 'antd';
import InputSelectField from '../../../../../components/mobile/form-helpers/InputSelectField';
import HeaderScreening from '../../../../../components/mobile/sign-up/HeaderScreening';
import SharedWithList from '../../../../../components/mobile/medical-history/SharedWithList'
import { FormInputArea } from '../../../../../components/mobile/form-helpers/FormField';

const { Title } = Typography;

const data = [
  {label: 'Agomelatine', value: 'Agomelatine'},
  {label: 'Azelaic Acid', value: 'Azelaic Acid'},
  {label: 'Azelastine hydrochloride nasal spray', value: 'Azelastine hydrochloride nasal spray'},
  {label: 'Malatonin', value: 'Malatonin'},
]

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  }
}

function MobileAlergiesScreen({fieldName, step, count}) {
  const { t } = useTranslation(['medical-history', 'common']);
  const history = useHistory();
  const { values, setFieldValue } = useFormikContext();
  const [lists, setLists] = useState(values[fieldName]);

  const handleChange = (name, val) => {
    const temp = {label: val, value: val};
    const arr = [...lists, temp];
    setLists(arr);
    setFieldValue(fieldName, arr);
  }

  const onRemove = (val) => {
    const arr = lists.filter(function(obj) {
      return obj.value !== val;
    });
    setLists(arr);
    setFieldValue(fieldName, arr);
  }

  return (
    <>
      <HeaderScreening
        count={count}
        step={step}
        title={t('medical-history:allergies.title')}
        subtitle={t('medical-history:allergies.subtitle')}
      />
      <Divider />
      <Col xs={24}>
        <FormInputArea
          name={fieldName}
          style={{ width: '100%', padding: '3%' }}
          formItemLayout={formItemLayout}
          onChange={(e) => setFieldValue(fieldName, e.target.value)}
          value={values[fieldName]}
          rows={6}
        />
        {/* <InputSelectField
          name="temp_allergies"
          label={t('medical-history:allergies.form.enterAllergy.label')}
          placeholder={t('medical-history:allergies.form.enterAllergy.placeholder')}
          options={data}
          handleChange={handleChange}
        />
        <Box>
          <SharedWithList
            title={t('medical-history:allergies.form.yourAllergies.label')}
            emptyTitle={t('medical-history:allergies.form.yourAllergies.noSelected')}
            list={lists}
            onRemove={onRemove} />
        </Box> */}
      </Col>
    </>
  );
}

export default MobileAlergiesScreen;
